import * as React from 'react';
import { Box } from '@apia/theme';
import { customEvents } from '../../../../utils/dom';

export interface IFieldErrorMsg {
  children: React.ReactNode | string;
  name?: string;
}

const FieldErrorMsg = ({
  children,
  name,
}: IFieldErrorMsg): JSX.Element | null => {
  const [ref, setRef] = React.useState<null | HTMLDivElement>(null);

  React.useEffect(() => {
    if (children) {
      const event = new CustomEvent(customEvents.focus, { bubbles: true });
      ref?.dispatchEvent(event);
    }
  }, [children, ref]);

  if (children) {
    return (
      <Box
        as="strong"
        ref={setRef}
        role="alert"
        className="fieldErrorMessage"
        {...window.getVariant('layout.common.components.fieldError')}
        data-testid={name ? `err_${name}` : null}
      >
        {children}
      </Box>
    );
  }
  return null;
};

export default FieldErrorMsg;
